module.exports = __webpack_public_path__ + "img/mx.db12a526.svg";